/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';

class ProfileView extends Backbone.View {
  static initClass() {
    this.prototype.el = '#profile';
    this.prototype.events = {'click .nav-tabs a': 'handleTabClick'};
  }

  initialize() {
    $(window).on('hashchange.profileview', () => this.setTabFromHash());
  }

  remove() {
    $(window).off('.profileview');
    return super.remove();
  }

  handleTabClick(e) {
    window.location.hash = $(e.currentTarget).attr('href').substring(1);
  }

  setTabFromHash() {
    let $tab = this.$('.nav-tabs a').filter(function () {
      return $(this).attr('href') === window.location.hash;
    });
    if ($tab.length === 0) {
      $tab = this.$('.nav-tabs a:eq(0)');
    }
    $tab.tab('show');
    return this;
  }
}
ProfileView.initClass();

export default ProfileView;
